import { useQuery } from 'react-query';
import { useToast } from 'hooks/useToast';
import DocumentsAPI from 'services/API/DocumentsAPI';
import ProjectsAPI from 'services/API/ProjectsAPI';
import { dedupeLandTitleChangeEvents } from 'utils/activity';
import { renameDocuments } from 'utils/renameDocuments';

export const useProjectActivitySummary = (projectSlug: string) => {
  const { renderToast } = useToast();

  return useQuery(
    ['get-project-activity-summary', projectSlug],
    async () => {
      const result = await ProjectsAPI.getProjectEventsSummary(projectSlug);

      const response = result ? result.data : result;
      if (response) {
        response.summarized_activities = dedupeLandTitleChangeEvents(
          response.summarized_activities,
        ).map((activity) => ({
          ...activity,
          latest_activity: {
            ...activity.latest_activity,
            document_type: renameDocuments(activity.latest_activity.document_type),
          },
        }));
      }

      return response;
    },
    {
      enabled: !!projectSlug,
      refetchOnWindowFocus: false,
      onError: () => {
        renderToast({
          toastTitle: 'failed_to_load_activity_summary',
          title: 'Error loading stages',
          label: 'Please refresh to try again.',
          status: 'error',
        });
      },
    },
  );
};

export const useDocumentActivitySummary = (documentId: string) => {
  const { renderToast } = useToast();

  return useQuery(
    ['get-document-activity-summary', documentId],
    async () => {
      const result = await DocumentsAPI.getDocumentEventsSummary(documentId);

      const response = result ? result.data : result;
      if (response) {
        response.summarized_activities = dedupeLandTitleChangeEvents(
          response.summarized_activities,
        ).map((activity) => ({
          ...activity,
          latest_activity: {
            ...activity.latest_activity,
            document_type: renameDocuments(activity.latest_activity.document_type),
          },
        }));
      }

      return response;
    },
    {
      enabled: !!documentId,
      refetchOnWindowFocus: false,
      onError: () => {
        renderToast({
          toastTitle: 'failed_to_load_activity_summary',
          title: 'Error loading stages',
          label: 'Please refresh to try again.',
          status: 'error',
        });
      },
    },
  );
};
